import request from '@ps/utils/request'
import { AxiosRequestConfig } from 'axios'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getCommonComponentList(
  params: {
    type?: number
    page: number
    page_size: number
    size_max?: number
    formats?: string
    skeleton_type?: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: '/common/asset/list',
    method: 'get',
    params: {
      ...params,
      page_size: 1000,
    },
    ...config,
  })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getCommonComponentSceneList(
  params: {
    type: number
    page: number
    page_size: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: '/ps/common/asset/list2',
    method: 'get',
    params: params,
    ...config,
  })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function readCommonComponent(params: { id: number }) {
  return request({
    url: '/ps/common/asset/read',
    method: 'get',
    params: params,
  })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getHotCommonComponentList(
  params: {
    types: number
    limit?: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: '/ps/common/asset/hot',
    method: 'get',
    params: params,
    ...config,
  })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getHotCommonComponentListSortWithTags(
  params: {
    types?: string
    limit?: number
    group_id?: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: '/ps/common/asset/hotbytags',
    method: 'get',
    params: params,
    ...config,
  })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getCommonAssetByCat(
  params: {
    types: string
    limit?: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: '/ps/common/asset/hotbycat',
    method: 'get',
    params: params,
    ...config,
  })
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function getTagList() {
  return request({
    url: '/ps/common/asset/tags',
    method: 'get',
  })
}

// 返回主标签和资源列表
// http://playable.dev.com:8067/index.html?urls.primaryName=Playturbo%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3#/playsmart/get_ps_common_asset_tag_list_asset
export function getMainTagAssetList(
  params: {
    type: number
    limit?: number
    tool?: number
    size_max?: number
    formats?: string
    skeleton_type?: number
    group_id?: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: '/common/asset-tag/assets',
    method: 'get',
    params,
    ...config,
  })
}

// 返回辅助标签
// http://playable.dev.com:8067/index.html?urls.primaryName=Playturbo%E6%8E%A5%E5%8F%A3%E6%96%87%E6%A1%A3#/playsmart/get_ps_common_asset_tag_list_assist
export function getAssetTag(
  params: {
    type: number
  },
  config: AxiosRequestConfig,
) {
  return request({
    url: '/common/asset-tag/assists',
    method: 'get',
    params,
    ...config,
  })
}

/**
 * 粒子另存为
 * @param data
 */
export function saveAs(data: {
  files: string // 图片帧，格式为 json 数组，如：「图片1的base64""图片2的base64m
  img_file: number // 每一帧的延迟时长．单位为1/100秒
  type: number
  name: string
  name_en: string
  public: number
  show_status: number
  copyright: number
  realize_method: number
  applicable_tools: string
  tag_ids: string
  description: string
}): Promise<{
  code: number
  data: {
    id: number
  }
  msg: string
}> {
  return request({
    url: '/ps/common/asset/save-as',
    method: 'post',
    data,
  })
}

/**
 * 获取资源信息
 * @param data
 */
export function getAssetInfo(data: { id: string }): Promise<{
  code: number
  data: {
    id: number
  }
  msg: string
}> {
  return request({
    url: '/common/asset/info',
    method: 'get',
    params: data,
  })
}
